import { frenchDateOnly } from "./dateFormatter";

export const formaterLesClients = (listeDesClients) => {
    return listeDesClients
        .map((client, index) => {
            if (client.numeroAssureM !== null && client.nom !== null) {
                const label = client.prenom !== null
                    ? `${client.nom} ${client.prenom}-${client.numeroAssureM}-${index}`
                    : `${client.nom}-${client.numeroAssureM}-${index}`;
                return { value: client.personneId, label: label.trim(), numeroAssure: client.numeroAssureM };
            }
            return null;
        })
        .filter(Boolean);
};

export const formaterLesContrats = (listeDesContrats) => {
    return listeDesContrats
        .map((contrat) => {
            if (contrat.numeroPoliceM !== null) {
                const label = contrat?.prenom !== null
                    ? `${contrat.numeroPoliceM} - ${frenchDateOnly(contrat?.dateEffet)} - ${contrat?.nom} ${contrat?.prenom} - ${contrat?.immatriculation}`
                    : `${contrat.numeroPoliceM} - ${frenchDateOnly(contrat?.dateEffet)} - ${contrat?.nom} - ${contrat?.immatriculation}`;
                return { value: contrat.codeId, label: label.trim(), numeroPolice: contrat.codeId, contrat };
            } else if (contrat.numeroPoliceP !== null && contrat.nom !== null) {
                const label = contrat?.prenom !== null
                    ? `${contrat.numeroPoliceP} - ${frenchDateOnly(contrat?.dateEffet)} - ${contrat?.nom} ${contrat?.prenom} - ${contrat?.immatriculation}`
                    : `${contrat.numeroPoliceP} - ${frenchDateOnly(contrat?.dateEffet)} - ${contrat?.nom} - ${contrat?.immatriculation}`;
                return { value: contrat.codeId, label: label.trim(), numeroPolice: contrat.codeId, contrat };
            }
            return null;
        })
        .filter(Boolean);
};

export const getEnginsFromContrat = (contrat) => {
    return [{ value: contrat?.immatriculation, label: contrat?.immatriculation }];
};

export const formaterLesEntites = (listeDesEntites) => {
    return listeDesEntites.map((entite) => ({
        value: entite.entiteConstatId,
        label: entite.adresse !== null ? `${entite?.nom} - ${entite?.adresse}` : `${entite?.nom}`,
        entite,
    }));
};
